export const loadingSelector = (state) => state.loading;
export const vehiclesSelector = (state) => state.vehicles;
export const widgetDataSelector = (state) => state.widgetData;
